// extracted by mini-css-extract-plugin
export default {"page":"page_page__9qWxm","content":"page_content__U707p","loading":"page_loading__Ju+4X","footer":"page_footer__q3b8E"};